/**
 * Load the source for Recon Dashboard WebComponent, which is used in the Recon Dashboard panel
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export function loadReconDashboardScript(document: Document) {
  const now = Date.now()
  const jsPath = '/plugin/recon-dashboard/recon-dashboard.js'
  const script = document.getElementById('reconDashboardUrl')
  script?.setAttribute('src', `${jsPath}?v=${now}`)
}
